module.exports = __webpack_public_path__ + "static/media/star.2e1ba3a8.svg";